import { Text } from "@mantine/core";

interface FilterSectionLabelProps {
  children: React.ReactNode;
}

/**
 * Consistent label component for filter sections.
 * Ensures uniform spacing and styling across all filter labels.
 */
const FilterSectionLabel = ({ children }: FilterSectionLabelProps) => {
  return (
    <Text
      size="sm"
      fw={600}
      c="dimmed"
      mt={0}
      mb="xs"
      style={{
        lineHeight: 1,
        margin: 0,
        marginBottom: "0.625rem",
        padding: 0,
        display: "flex",
        alignItems: "center",
        height: "auto",
      }}
    >
      {children}
    </Text>
  );
};

export default FilterSectionLabel;
